/* eslint-disable import/prefer-default-export */
export const PUBLIC_GOOGLE_MAPS_API_KEY = 'AIzaSyCm4LO63674TK9CdhOQQ-YK0CgK2P-RKy0';
